<template>
  <div id="app-view" :class="appClasses">
    <main class="lnx-container">
      <CalculationView />
    </main>
    <footer class="lnx-container">
      <div class="lnx-row lnx-no-gutters">
        <div class="lnx-col-12 app-footer">
          <p class="footer-text" v-html="$t('content.footer_text')"></p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { AppThemeKeys } from '@/keys/app-theme.keys.ts'

import CalculationView from '@/views/calculation/CalculationView.vue'

const appClasses = computed(() => ({
  linexo: true,
  'light-theme': appTheme === AppThemeKeys.BIKE
}))

const appTheme = AppThemeKeys[import.meta.env.VITE_APP_THEME]
</script>
